import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/services/support/SupportClient.tsx");
